<template>
<div class="case-banner">

    <div class="case-banner__title-bar">
        <div class="case-banner__title-bar__title">
            Recent work
        </div>

        <div class="case-banner__title-bar__show-all">
            <router-link to="/cases">
                <svg version="1.1"
                     id="Capa_1"
                     xmlns="http://www.w3.org/2000/svg"
                     xmlns:xlink="http://www.w3.org/1999/xlink"
                     x="0px"
                     y="0px"
                     width="514.08px"
                     height="514.08px"
                     viewBox="0 0 514.08 514.08"
                     style="enable-background:new 0 0 514.08 514.08;"
                     xml:space="preserve">
                    <g>
                        <g>
                            <rect y="0.961" width="207.168" height="207.168"/>
                            <rect x="306.912" y="0.961" width="207.168" height="207.168"/>
                            <rect y="305.951" width="207.168" height="207.168"/>
                            <rect x="306.912" y="305.951" width="207.168" height="207.168"/>
                        </g>
                    </g>
                </svg>View all</router-link>
        </div>
    </div>

    <ul class="case-banner__cases" slide-show>

        <li class="case-banner__case"
            v-for="item in cases"
            :key="item.id">
            <CardCase :id="item.id" />
        </li>

    </ul>

</div>
</template>

<script>
// vue helpers
import { mapState } from 'vuex'

// mixins
import SlideShow from "./../mixins/slide-show";

// components
import CardCase from '@/components/CardCase.vue'

export default {
    name: 'caseBanner',
    mixins: [ SlideShow ],
    components: {
        CardCase
    },
    computed: mapState({
        shouldShow(state) {
            return state.settings.bannerCases
        },
        cases(state) {
            return state.data.cases.filter(item => this.shouldShow.includes(item.id))
        },
    }),
}
</script>

<style lang="scss">
@import "../scss/globals.scss";

.case-banner {
    position: relative;
    z-index: 1;
    padding: 0 0 $margin1-1;
    background-color: $color-dark-grey;
    color: $color-white;

    pointer-events: all;
    @media screen and (min-width: 377px) {
        padding: 0 0 $margin2-1;
    }
    @media screen and (min-width: 769px) {
        padding: 0 0 $margin2-1;
    }
    @media screen and (min-width: 1025px) {
        padding: 0 $margin1-1 $margin2-1;
    }

    &__title-bar {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        height: $margin1-2;
        padding: $margin1-1 $margin1-8 0;
        @media screen and (min-width: 377px) {
            padding: $margin2-1 $margin1-4 0;
        }
        @media screen and (min-width: 769px) {
            padding: $margin2-1 $margin1-2 0;
        }
        @media screen and (min-width: 1025px) {
            padding: $margin2-1 0 0;
        }

        &__title {
            font-family: $font-expanded;
            font-size: $font-size-s;
        }

        a {
            font-family: $font-expanded;
            color: $color-white;
            font-size: $font-size-xxs;
            @media screen and (min-width: 440px) {
                font-size: $font-size-xs;
            }
        }

        &__show-all {
            font-size: $font-size-xs;

            z-index: 10;

            svg {
                transition: transform .2s;
                transform: rotate(0.000001deg);
                width: 0.8em;
                height: 0.8em;
                margin-bottom: -.05em;
                margin-right: 0.5em;
                fill: $color-white;
            }

            &:hover {
                svg {
                    transform: rotate(90deg);
                }
            }
        }
    }

    ul {
        display: block;
        margin: 0.5em 0 0;

        list-style: none;
        padding: 0;

        overflow: hidden;
        outline: none;
        @media screen and (min-width: 1025px) {
            display: flex;
            margin: calc(#{$margin1-8} * -1);
        }

        li {
            box-sizing: border-box;

            width: 75%;
            display: inline;
            padding: $margin1-4;
            
            @media screen and (min-width: 1025px) {
                display: block;
                width: 50%;
                margin: 0;
                padding: $margin1-8;
            }
        }
    }
}
</style>
